import { render, staticRenderFns } from "./DeliveryDateDetails.vue?vue&type=template&id=27170d76&scoped=true"
import script from "./DeliveryDateDetails.vue?vue&type=script&lang=js"
export * from "./DeliveryDateDetails.vue?vue&type=script&lang=js"
import style0 from "./DeliveryDateDetails.vue?vue&type=style&index=0&id=27170d76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27170d76",
  null
  
)

export default component.exports